import { AUTH_LABEL_CLASS } from "@/components/AuthShell";
import { LABEL_RENTANG_USIA, TEKS_PILIH_INSTITUSI_DULU, TEKS_TANPA_PILIHAN_PRODI, labelProdiKepnakes, prodiDariInstitusi } from "@/lib/survei";

// Langkah demografi survei Kepnakes (PR #112): semua pilihan dari server (GET /survei/publik/{kode}/pilihan), tanpa isian
// bebas. Dropdown bawaan browser (<select>) supaya nyaman di HP. Jenis Kelamin hanya bila ditanyakan periode ini
// (pilihan.jenis_kelamin bukan null). Program Studi bertingkat: nonaktif sampai Institusi dipilih, lalu hanya milik institusi
// itu; ganti institusi mengosongkan Program Studi; institusi tanpa Program Studi aktif -> keterangan & boleh lanjut.
const KELAS_PILIH = "h-12 w-full rounded-md border border-input bg-background px-3 text-base text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";

function Pilih({ id, label, nilai, onUbah, opsi, nonaktif = false, bantuan = "" }) {
    return (
        <div className="space-y-1.5">
            <label htmlFor={id} className={AUTH_LABEL_CLASS}>{label}</label>
            <select id={id} data-testid={id} value={nilai || ""} onChange={(e) => onUbah(e.target.value)} disabled={nonaktif}
                    aria-describedby={bantuan ? `${id}-bantuan` : undefined} className={`${KELAS_PILIH} disabled:cursor-not-allowed disabled:opacity-60`}>
                <option value="" disabled>Pilih…</option>
                {opsi.map((o) => <option key={o.nilai} value={o.nilai}>{o.label}</option>)}
            </select>
            {bantuan && <p id={`${id}-bantuan`} className="text-xs text-muted-foreground" data-testid={`${id}-bantuan`}>{bantuan}</p>}
        </div>
    );
}

export default function SurveiDemografiKepnakes({ pilihan, nilai, onUbah }) {
    const ubah = (kunci) => (v) => onUbah((x) => ({ ...x, [kunci]: v }));
    const ubahInstitusi = (v) => onUbah((x) => ({ ...x, institusi_id: v, prodi_id: "" }));
    const prodi = prodiDariInstitusi(pilihan, nilai.institusi_id);
    const bantuanProdi = !nilai.institusi_id ? TEKS_PILIH_INSTITUSI_DULU : (prodi.length === 0 ? TEKS_TANPA_PILIHAN_PRODI : "");
    return (
        <div className="space-y-4" data-testid="survei-demografi">
            <div>
                <h2 className="text-lg font-bold text-foreground">Data responden</h2>
                <p className="mt-1 text-xs text-muted-foreground">Pilihan ini dipakai untuk melaporkan hasil secara kelompok, bukan per individu.</p>
            </div>
            <div className="space-y-4 md:grid md:grid-cols-2 md:gap-6 md:space-y-0">
                <Pilih id="survei-institusi" label="Institusi pendidikan" nilai={nilai.institusi_id} onUbah={ubahInstitusi}
                       opsi={pilihan.institusi.map((i) => ({ nilai: i.id, label: i.nama }))} />
                <Pilih id="survei-prodi-kepnakes" label="Program Studi" nilai={nilai.prodi_id} onUbah={ubah("prodi_id")}
                       nonaktif={!nilai.institusi_id || prodi.length === 0} bantuan={bantuanProdi}
                       opsi={prodi.map((p) => ({ nilai: p.id, label: labelProdiKepnakes(p) }))} />
                <Pilih id="survei-rentang-usia" label="Rentang usia" nilai={nilai.rentang_usia} onUbah={ubah("rentang_usia")}
                       opsi={pilihan.rentang_usia.map((r) => ({ nilai: r, label: LABEL_RENTANG_USIA[r] || r }))} />
                {pilihan.jenis_kelamin && (
                    <Pilih id="survei-jenis-kelamin" label="Jenis kelamin" nilai={nilai.jenis_kelamin} onUbah={ubah("jenis_kelamin")}
                           opsi={pilihan.jenis_kelamin.map((j) => ({ nilai: j, label: j }))} />
                )}
            </div>
        </div>
    );
}
